/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { InputText } from 'primereact/inputtext';
import ManagedAccountRow from './ManagedAccountRow';

const i18nMessages = defineMessages({
  name: { id: 'attrs.name', defaultMessage: 'Name' },
  id: { id: 'attrs.id', defaultMessage: 'Id' },
  status: { id: 'attrs.status', defaultMessage: 'Status' },
  noSubscriptions: {
    id: 'business-center.no-subscriptions',
    defaultMessage: 'There are currently no account subscriptions to manage',
  },
});

const ManagedAccounts = ({ accounts, handleRowClick }) => {
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [filterQuery, setFilterQuery] = useState(null);

  const { formatMessage } = useIntl();

  useEffect(() => {
    setFilteredAccounts([...accounts]);
  }, [accounts]);

  useEffect(() => {
    setFilteredAccounts(
      accounts.filter((account) => account.displayName.toLowerCase().includes(filterQuery.toLowerCase())),
    );
    // eslint-disable-next-line
  }, [filterQuery]);

  if (accounts.length === 0) {
    return (
      <div className="align-center">
        <h3>{formatMessage(i18nMessages.noSubscriptions)}</h3>
      </div>
    );
  }

  return (
    <>
      <div>
        <InputText
          value={filterQuery}
          placeholder="Filter by name..."
          onChange={(event) => setFilterQuery(event.target.value)}
        />
      </div>
      <br />
      <div className="managed-accounts-header">
        <div>
          <strong>{formatMessage(i18nMessages.name)}</strong>
        </div>
        <div>
          <strong>{formatMessage(i18nMessages.id)}</strong>
        </div>
        <div>
          <strong>{formatMessage(i18nMessages.status)}</strong>
        </div>
      </div>
      {filteredAccounts.map((account) => (
        <ManagedAccountRow key={account.id} account={account} handleRowClick={handleRowClick} />
      ))}
    </>
  );
};

ManagedAccounts.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.any).isRequired,
  handleRowClick: PropTypes.func.isRequired,
};

export default ManagedAccounts;
